import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Heading, Text } from '@components/common';
import DialogBox from '@components/DialogBox';
import { MobileContainer } from '@containers/layout';
import CancelConfirm from '@containers/booking/Confirm/CancelConfirm';
import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import ScheduleActions from '@redux/ScheduleRedux';
import ModifyCheckoutForm from './ModifyCheckoutForm';
import { FREQUENCIES, SURCHARGE_TEXT } from '@services/minte';

function Confirm(props) {
  const { selectedFrequency, cancelBooking, onSubmit } = props;
  const [show, toggleModal] = useState(false);

  const handleCancel = () => {
    handleDissmisModal();
    cancelBooking();
  };

  const handleShowModal = () => {
    toggleModal(true);
  };

  const handleDissmisModal = () => {
    toggleModal(false);
  };

  return (
    <MobileContainer
      pt={[0, selectedFrequency === FREQUENCIES.REGULARLY ? 6 : 0]}
    >
      <Heading px={2} mb={4} mt={0}>
        Confirm Modify
      </Heading>

      <ModifyCheckoutForm onSubmit={onSubmit} onCancel={handleShowModal} />
      <Text fontSize={0} color="grey.0" mb={4}>
        {SURCHARGE_TEXT}
      </Text>
      <DialogBox show={show} onClickOutside={handleDissmisModal}>
        <CancelConfirm onSubmit={handleCancel} onCancel={handleDissmisModal} />
      </DialogBox>
    </MobileContainer>
  );
}

Confirm.propTypes = {
  selectedFrequency: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  cancelBooking: PropTypes.func
};

const mapStatesToProps = state => ({
  selectedFrequency: BookingSelectors.selectFrequency(state)
});

const mapDispatchToProps = dispatch => ({
  cancelBooking: () => {
    dispatch(BookingActions.resetBooking(true));
    dispatch(ScheduleActions.resetRecurringBooking());
  }
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(Confirm);
